// extracted by css-extract-rspack-plugin
export default {"radio":"radio-MwmUez","panel":"panel-_L0hWK","badge":"badge-wyN3xX","active":"active-B5I5zN","violet":"violet-QTHo9H","yellow":"yellow-dFQHj5","pink":"pink-lM999o"};